// const tableStyle = {
//     root: {
//         borderRadius: '10px',
//         "& th": {
//             color: "white",
//             backgroundColor: "#404040",
//           },
//           "& tr": {
//             height: '10px', // Adjust the height as needed
//           },
//           maxHeight: '300px', // Limit the table height
//           overflowY: 'auto', // Enable vertical scrolling
//     },
//   };
  
//   export default tableStyle;

  const tableStyle = {
    root: {
      height: '30px'
    },
  };
  
  export default tableStyle;